module.exports = __webpack_public_path__ + "img/device-7.bd1f9c5e.png";